<app-header></app-header>

<div class="container">
    <ng-content></ng-content>
</div>